export enum EDDWindows {
  TODAY = "Discharges today",
  TOMORROW = "Discharges tomorrow",
  DAY_AFTER_TOMORROW = "Discharges in 2 days",
  ALL = "All",
}
